import { createAction, props } from '@ngrx/store';
import { Config } from 'src/app/models/config.interface';


export const loadConfig = createAction(
  '[Config API Service] Load survey configuration',
  props<{ config: Config }>()
);

export const loadConfigError = createAction(
  '[Config API Service] Write error message',
  props<{ error: any }>()
);

export const loadConfigSuccess = createAction(
  '[Config API Service] Load survey configuration',
);

